var NetPromoterScoreModalModule = /** @class */ (function () {
    function NetPromoterScoreModalModule() {
    }
    return NetPromoterScoreModalModule;
}());
export { NetPromoterScoreModalModule };
